import { render } from "./LiveChat.vue?vue&type=template&id=454e26dc"
import script from "./LiveChat.vue?vue&type=script&lang=js"
export * from "./LiveChat.vue?vue&type=script&lang=js"

import "./LiveChat.vue?vue&type=style&index=0&id=454e26dc&lang=css"
import "./LiveChat.vue?vue&type=style&index=1&id=454e26dc&lang=css"

import exportComponent from "/Users/dcoffey/projects/pubnub-chat/live-chat/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__